<template>
  <div>
    <!-- 筛选查询 -->
    <div class="wScreenArea">
      <el-card class="box-card">
        <div slot="header" class="wScreenCardHeader">
          <span>筛选查询</span>
        </div>
        <el-form
          label-position="left"
          label-width="90px"
          @submit.native.prevent
        >
          <el-row :gutter="20">
            <el-col :span="7">
              <el-form-item label="门店">
                <el-select
                  v-model="selectedStore"
                  placeholder="选择门店"
                  style="width: 100%"
                  @change="onStoreChange"
                >
                  <el-option
                    v-for="s in stores"
                    :key="s.id"
                    :label="s.name"
                    :value="s.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="时间范围">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="会员等级">
                <el-select
                  v-model="selectedMembership"
                  placeholder="全部等级"
                  clearable
                  style="width: 100%"
                  @change="onMembershipChange"
                >
                  <el-option
                    v-for="item in membershipOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="5"
              style="display: flex; align-items: center; gap: 8px"
            >
              <el-button @click="applyFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <!-- 核销列表 -->
    <div class="wTableArea">
      <el-table border :data="tableData" v-loading="loading">
        <el-table-column
          prop="storeName"
          label="门店"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="giftName"
          label="礼包名称"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="userPhone"
          label="核销员电话"
          align="center"
          width="130"
        />
        <el-table-column
          prop="userPhoneNumber"
          label="用户电话"
          align="center"
          width="130"
        />
        <el-table-column
          prop="redeemTime"
          label="核销时间"
          align="center"
          width="180"
        />
        <el-table-column
          prop="redeemCode"
          label="核销码"
          align="center"
          width="160"
          class-name="redeem-code-column"
        />
      </el-table>

      <!-- 分页 -->
      <div class="wPagination">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreManagerListApi, getVerificationCode } from "@/network/wApi.js";

export default {
  data() {
    return {
      selectedStore: "",
      selectedMembership: "",
      stores: [],
      redeemStatus: "",
      dateRange: "",
      allTableData: [],
      tableData: [],
      loading: false,
      membershipOptions: [
        { label: "会员", value: 814 },
        { label: "VIP会员", value: 815 },
        { label: "渠道代理", value: 816 },
        { label: "社区团长", value: 817 },
        { label: "区县代理", value: 818 },
        { label: "区县云仓", value: 819 },
        { label: "市级代理", value: 820 },
        { label: "省分公司", value: 821 },
        { label: "轻创代理", value: 822 },
        { label: "董事合伙人", value: 823 },
        { label: "开店连锁", value: 824 },
      ],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getStoreList();
  },
  methods: {
    // 获取门店列表
    getStoreList() {
      this.loading = true;
      let userInfo = localStorage.getItem("USER_INFO");
      let userId = "";
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          userId = userInfo.id || "";
        } catch (e) {}
      }

      getStoreManagerListApi({ userId })
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.stores = res.map((store) => ({
              id: store.id,
              name: store.storeName,
            }));
            if (this.stores.length > 0) {
              this.selectedStore = this.stores[0].id;
              this.fetchData();
            }
          } else if (res && res.records && Array.isArray(res.records)) {
            this.stores = res.records.map((store) => ({
              id: store.id,
              name: store.storeName,
            }));
            if (this.stores.length > 0) {
              this.selectedStore = this.stores[0].id;
              this.fetchData();
            }
          } else {
            this.stores = [];
          }
        })
        .catch((err) => {
          console.error("获取门店列表失败:", err);
          this.stores = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取核销数据
    fetchData() {
      this.loading = true;

      const data = {
        pageNo: 1,
        pageSize: 10000,
        storeId: this.selectedStore,
      };

      // 时间范围筛选
      if (this.dateRange && this.dateRange.length === 2) {
        data.start = this.formatDate(this.dateRange[0]);
        data.end = this.formatDate(this.dateRange[1]);
      }

      if (
        this.selectedMembership !== "" &&
        this.selectedMembership !== null &&
        this.selectedMembership !== undefined
      ) {
        data.membership = this.selectedMembership;
      }

      console.log("请求参数:", data);

      getVerificationCode(data)
        .then((res) => {
          console.log("核销数据返回:", res);
          const records = Array.isArray(res)
            ? res
            : res && Array.isArray(res.records)
            ? res.records
            : [];

          this.allTableData = records.map((item) => this.formatTableRow(item));
          this.updateTableData();
        })
        .catch((err) => {
          console.error("获取核销数据失败:", err);
          this.allTableData = [];
          this.tableData = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatTableRow(item) {
      return {
        orderNo: item.orderId || item.orderNo || "-",
        storeName: item.storeName || "-",
        giftName: item.verificationName || "-",
        userPhone: this.maskPhone(item.userPhone || item.phone || ""),
        userPhoneNumber: item.userPhoneNumber || "-",
        status: item.status,
        redeemTime: item.verificationTime || item.redeemTime || "-",
        redeemCode: item.verificationNumber || item.code || "-",
        membership: item.membership,
      };
    },

    updateTableData() {
      const maxPage = Math.ceil(this.allTableData.length / this.pagination.size) || 1;
      if (this.pagination.current > maxPage) {
        this.pagination.current = maxPage;
      }

      const start = (this.pagination.current - 1) * this.pagination.size;
      const end = start + this.pagination.size;
      this.tableData = this.allTableData.slice(start, end);
      this.pagination.total = this.allTableData.length;
    },

    // 手机号脱敏
    maskPhone(phone) {
      if (!phone || phone.length < 7) return phone;
      return phone.substring(0, 3) + "****" + phone.substring(phone.length - 4);
    },

    // 日期格式化
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 门店变化
    onStoreChange() {
      this.pagination.current = 1;
      this.fetchData();
    },

    onMembershipChange() {
      this.pagination.current = 1;
    },

    // 查询
    applyFilter() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 重置
    resetFilter() {
      this.selectedStore = this.stores.length > 0 ? this.stores[0].id : "";
      this.selectedMembership = "";
      this.redeemStatus = "";
      this.dateRange = "";
      this.pagination.current = 1;
      this.fetchData();
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.current = 1;
      this.updateTableData();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.updateTableData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";

.wScreenCardHeader {
  display: flex;
  align-items: center;
}

/deep/ .redeem-code-column .cell {
  white-space: nowrap;
}
</style>
